/* eslint-disable */


/**
 * Create styles for `<ReportsPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ReportsPage />` styles
 */
const reportsPageStyles = ({ theme }) => ({
  reportType: {
    marginBottom: theme.spacing(1) * 2,
  },
  link: {
    '&:hover': {
      textDecoration: `underline`,
    },
    color: theme.palette.grey[700],
    textDecoration: `none`,
  },
});

export default reportsPageStyles;
